<template>
  <div>
    <v-form
      ref="reviewForm"
      v-model="reviewFormValid"
      @submit.prevent="submitReview"
    >
      <label for="review">Manuscript Review *</label>
      <vue-pell-editor
        :placeholder="editorPlaceholder"
        :actions="editorOptions"
        :style-with-css="false"
        :classes="editorClasses"
        default-paragraph-separator="p"
        v-model="reviewOutput"
        class="mb-2 mt-1"
        id="review"
      />

      <v-autocomplete
        :rules="rules.required"
        :items="recommendations"
        item-text="label"
        item-value="value"
        label="Recommendation after review *"
        v-model="recommendation"
        required
        outlined
      ></v-autocomplete>

      <v-file-input
        outlined
        show-size
        v-model="file"
        label="Reference file (optional; multiple files can be zipped)"
        :rules="rules.attachment"
        :accept="wordPDFOrZip"
        prepend-icon="mdi-file-document"
      ></v-file-input>

      <v-btn
        x-large
        type="submit"
        color="green"
        :loading="saving"
        class="white--text"
        :disabled="saving || !reviewFormValid || reviewOutput.length < 1"
      >
        Submit Review
        <v-icon right>mdi-content-save-edit</v-icon>
      </v-btn>
    </v-form>
  </div>
</template>


<script>
import dedent from "dedent";
import { editorOptions } from "../../../tools/wysiwyg";
import { required, attachment } from "../../../tools/rules";

export default {
  props: {
    invitation: {
      type: String,
    },
    manuscript: {
      type: String,
    },
  },

  data: () => ({
    file: null,
    saving: false,
    recommendation: null,
    recommendations: [
      { label: "Accept Manuscript", value: "ACCEPT" },
      { label: "Manuscript Requires Minor Revision", value: "MINOR-REVISION" },
      { label: "Manuscript Requires Major Revision", value: "MAJOR-REVISION" },
      { label: "Reject Manuscript", value: "REJECT" },
    ],

    reviewOutput: "",
    wysiwygOption: "",

    reviewFormValid: false,
    rules: {
      attachment,
      required,
    },

    editorOptions,

    editorPlaceholder: "Paste or type here..",
    editorClasses: {
      actionbar: "pell-actionbar",
      button: "pell-button",
      content: "pell-content",
      selected: "pell-button-selected",
    },

    wordPDFOrZip:
      "application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed",
  }),
  methods: {
    submitReview() {
      if (!this.saving) {
        this.saving = true;

        let formData = new FormData();
        formData.append("recommendation", this.recommendation);
        formData.append("manuscript", this.manuscript);
        formData.append("invitation", this.invitation);
        formData.append("file", this.file);
        formData.append("review", this.cleanReviewText(this.reviewOutput));

        // this.description && formData.append("description", this.description);

        this.$axios
          .post(`/reviews/${this.manuscript}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            this.$bus.$emit("snackbar", {
              type: "success",
              message: "Review has been submitted",
            });
            this.$refs.reviewForm.reset();
            this.$router.go(-1);
          })
          .catch(() => {
            this.$bus.$emit("snackbar", {
              type: "error",
              message: "Could not submit review",
            });
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    cleanReviewText(text) {
      return dedent(text.replace(/style="(.*?)" /g, ""));
    },
  },
};
</script>

<style lang="scss" >
.question-text {
  font-size: 1.1rem;
}

.pell-actionbar {
  font-size: 1.3em;
  padding: 0.25em;
  border-radius: 4px 4px 0 0;
  border: 1px solid #bbb;
  // background-color: #bbb !important;
  // background-color: rgb(120, 230, 153) !important;
}

.pell-content {
  /* height: 300px; */
  height: 170px !important;
  outline: 0;
  overflow-y: auto;
  // padding: 10px;
  border-radius: 0 0 4px 4px;
  border: 1px solid #bbb;
  border-top-color: transparent;
  margin-bottom: 1.66em;

  line-height: 1.2;
}
</style>

<style lang="scss" scoped>
label {
  font-size: 1.1em;
}
</style>